import { CookieMonster } from 'root/utils/cookies/cookieMonster';

export default function setBlogSubscriptionCookie(subscriptionForms) {
    return (function () {
        /*
         * Sets the 'subscribedToBlog' cookie name (if not set) on newsletter form submit event
         * @returns { undefined }
         * */
        const setCookieOnSubmit = () => {
            const cm = new CookieMonster();
            const subscribedToBlogCookie = 'subscribedToBlog';

            if (!cm.getCookie(subscribedToBlogCookie)) {
                subscriptionForms.forEach(subscriptionForm => {
                    subscriptionForm.addEventListener('submit', function () {
                        window.registerCookieComplianceCallback({
                            callback: () => cm.setCookie(subscribedToBlogCookie, 1, 365),
                            category: 'functional',
                            isCallOptanonWrapper: true,
                        });
                    });
                });
            }
        };

        return {
            setCookieOnSubmit,
        };
    })().setCookieOnSubmit();
}
